// Touch device
window.is_touch_device = function () {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
}

if (is_touch_device()) {
    document.documentElement.classList.add('touch');
} else {
    document.documentElement.classList.add('no-touch');
}


//------------------------------------------------------------------------------------------//
// VIEWPORT, DEVICE ETC
//------------------------------------------------------------------------------------------//

// Fix mobile 100vh with calc() css function - https://ilxanlar.medium.com/you-shouldnt-rely-on-css-100vh-and-here-s-why-1b4721e74487#b630
window.appHeight = function() {
    const doc = document.documentElement;
    doc.style.setProperty('--vh', (window.innerHeight*.01) + 'px');
}
window.addEventListener('resize', appHeight);
// Do initial
appHeight();



//------------------------------------------------------------------------------------------//
// FAVORITES COUNT
//------------------------------------------------------------------------------------------//

function checkFavorites() {


    // Header counter
    let count = 0;
    let favorites = localStorage.getItem('webienProductFavorites');
    if(favorites){
        favorites = JSON.parse(favorites);
        count = favorites.length;
    }



    if(favorites && Array.isArray(favorites)){
        // Update all favorite count elements
        let countElements = document.querySelectorAll('.webien-favorite-count');
        countElements.forEach(function(elem) {
            // select span
            let span = elem.querySelectorAll('span');
            span.forEach(function(s) {
                s.innerText = count;
                elem.classList.add('show');
            });

            // If count is 0, remove show class
            if(count === 0){
                elem.classList.remove('show');
            }
        });
    }


    if(window.webienProductId){
        // favorite button on single pages
        let favAddButton = document.querySelectorAll('.elementor-element.addFavourite');
        let favRemoveButton = document.querySelectorAll('.elementor-element.removeFavourite');

        // Get fastening option from url param
        let urlParams = new URLSearchParams(window.location.search);
        let fastening = urlParams.get('fastening');
        let isFavorite = false;
        if(favorites && Array.isArray(favorites)){
            isFavorite = favorites.find(obj => obj.id === window.webienProductId);
            if(fastening){
                isFavorite = favorites.find(obj => obj.id === window.webienProductId && obj.fastening === fastening);
            }
        }

        favAddButton.forEach(function(button) {
            button.addEventListener('click', function() {
                updateFavorites();
            });
        });

        favRemoveButton.forEach(function(button) {

            // If this id is in storage, show remove button
            if(isFavorite){
                button.classList.add('show');
            } else {
                button.classList.remove('show');
            }

            button.addEventListener('click', function() {
                updateFavorites(true);
            });
        });
    }


}
checkFavorites();


function updateFavorites(remove= false){
    if(!window.webienProductId) return;

    // Get fastening option from url param
    let urlParams = new URLSearchParams(window.location.search);
    let fastening = urlParams.get('fastening');

    console.log('Current product ID:', window.webienProductId, 'Fastening option:', fastening);

    let item = {
        id: window.webienProductId
    };
    if(fastening){
        item.fastening = fastening;
    }


    let favorites = localStorage.getItem('webienProductFavorites');
    if(!favorites){
        favorites = [];
    } else {
        favorites = JSON.parse(favorites);
    }

    if(remove){
        // Remove from favorites
        if(fastening){
            favorites = favorites.filter(obj => !(obj.id === window.webienProductId && obj.fastening === fastening));
        } else {
            favorites = favorites.filter(obj => obj.id !== window.webienProductId);
        }
    } else {
        // Add to favorites if not already there
        let exists = favorites.find(obj => obj.id === window.webienProductId);
        if(fastening){
            exists = favorites.find(obj => obj.id === window.webienProductId && obj.fastening === fastening);
        }
        if(!exists){
            favorites.push(item);
        }
    }
    localStorage.setItem('webienProductFavorites', JSON.stringify(favorites));
    // Update count
    checkFavorites();

}
